import React, { useState, useEffect } from "react";

import AuthUser from "../../services/AuthUser";

import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import CircularScrollProgress from "../Circularprogress";
import FileUploadForm from "../User/FileUploadForm";
import RightSidebarAds from "./TopRightAd";



export const AgentUploads = () => {
  const [user, setUser] = useState({
    name: "",
    user_id: "",
    mobile: "",
    email: "",
  });

  const { http, token } = AuthUser();

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);



  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("agent"));
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  // ✅ Define fetchFiles at top level (before useEffect)
  const fetchFiles = async () => {
    try {
      setLoading(true);
      const response = await http.get("/agent-docs", {
        params: { user_id: user.user_id }
      });

      if (Array.isArray(response.data.documents)) {
        setFiles(response.data.documents);
      } else {
        setError("Invalid response format.");
      }
    } catch (err) {
      console.error("Error fetching files:", err);
      setError("Failed to fetch files");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Now use it inside the effect
  useEffect(() => {
    if (user && user.user_id) {
      fetchFiles();
    }
  }, [user.user_id]); // 👈 use user_id directly here


  // ✅ Utility
  const renderFilePreview = (file) => {
    const baseUrl = process.env.REACT_APP_API_URL;
    const ext = file.files_name.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif"].includes(ext)) {
      return <img src={`${baseUrl}/uploads/${file.files_name}`} alt="preview" width="100" />;
    } else if (ext === "pdf") {
      return <span>PDF Icon</span>;
    } else {
      return <span>Preview Unavailable</span>;
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this file?")) {
      try {
        await http.delete(`/delete-file/${id}`);
        // Refresh the list or remove from state
        // remove from state
        setFiles(prevFiles => prevFiles.filter(file => file.files_id !== id));
      } catch (err) {
        console.error("Error deleting file", err);
      }
    }
  };


  return (
    <div>


      <div>
        <div className="row">
          <div className="col-8">
            <div className="container mt-5">
              {/* <h2 className="mb-3">My Services</h2> */}
              <div className="row justify-content-center">
                <div className="col-md-11">
                  <div className="card shadow-sm ">
                    <div className="card-body">
                      <FileUploadForm onUploadSuccess={fetchFiles} />
                    </div>
                  </div>

                  {/* Documents Section (Grid View) */}
                  <div className="card shadow-sm mt-4">
                    <div className="card-body">
                      <h5 className="font-weight-bold">Uploaded Documents</h5>
                      <hr />

                      {loading ? (
                        <p>Loading documents...</p>
                      ) : error ? (
                        <p className="text-danger">{error}</p>
                      ) : files.length === 0 ? (
                        <p className="text-muted">No documents uploaded</p>
                      ) : (
                        <div className="row">
                          {[...files]
                            .sort((a, b) => new Date(b.created_time) - new Date(a.created_time)) // newest first
                            .map((doc) => (
                              <div key={doc.files_id} className="col-md-3 col-sm-6 mb-3">
                                <div className="card doc-card shadow-sm">
                                  <div className="text-center p-3">
                                    {renderFilePreview(doc)} {/* ✅ Use renderFilePreview here */}
                                  </div>
                                  <div className="card-body text-center">
                                    <h6 className="card-title">{doc.files_name}</h6>
                                    <p className="text-muted">{new Date().toLocaleDateString()}</p>
                                    <div className="d-flex justify-content-center gap-2">
                                      <a
                                        href={`${process.env.REACT_APP_API_URL}/uploads/${doc.files_name}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-sm btn-primary"
                                      >
                                        View
                                      </a>
                                      <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => handleDelete(doc.files_id)} // Call your delete function here
                                      >
                                        Delete
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>



                </div>
              </div>
            </div>

          </div>
          <div className="col-4">
            <div className="mt-5 p-3 rounded adds shadow" style={{ backgroundColor: '#f1f9ff', border: '2px solid #a0d4ff' }}>
              <h4 className="text-primary mb-3 text-center">🔥 Trending Ads</h4>
              <RightSidebarAds />
            </div>
          </div>
        </div>


        <div className="space40 bg-white"></div>
        <WhatsAppScrollButton />
        <Footer />
        <CircularScrollProgress />
      </div>

    </div>
  )
}
